"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiButton = function MuiButton() {
  return {
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '7px 32px'
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      padding: '8px 32px'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '8px 32px'
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 32px'
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '11px 32px',
      fontSize: '1.250rem'
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 32px'
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '12px 32px',
      fontSize: '1.250rem'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 32px'
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '12px 32px',
      fontSize: '1.250rem'
    }
  };
};

var _default = MuiButton;
exports["default"] = _default;